// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-chatbot-kit-chat-bot-message-container {
  display: flex;
  margin: 15px 0;
  justify-content: flex-start;
}

.react-chatbot-kit-chat-bot-avatar-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 1.2rem;
  margin-right: 12.5px;
  background-color: #d8d8d8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.react-chatbot-kit-chat-bot-avatar-icon {
  fill: #494646;
  width: 22.5px;
  height: 22.5px;
}

.react-chatbot-kit-chat-bot-avatar-letter {
  color: #1d1d1d;
  margin: 0;
  padding: 0;
}

.react-chatbot-kit-chat-bot-message {
  background-color: #2898ec;
  padding: 10px;
  border-radius: 5px;
  font-size: 0.9rem;
  color: #fff;
  font-weight: medium;
  position: relative;
  width: 184.5px;
  margin-left: auto;
  text-align: left;
}

.react-chatbot-kit-chat-bot-message-arrow {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #2898ec;
  position: absolute;
  left: -7px;
  top: 13px;
}

.react-chatbot-kit-chat-bot-loading-icon-container {
  height: 17px;
  width: 25px;
}

.chatbot-loader-container {
  display: flex;
  width: 100%;
  justify-content: center;
}

#chatbot-loader #chatbot-loader-dot1 {
  animation: load 1s infinite;
}

#chatbot-loader #chatbot-loader-dot2 {
  animation: load 1s infinite;
  animation-delay: 0.2s;
}

#chatbot-loader #chatbot-loader-dot3 {
  animation: load 1s infinite;
  animation-delay: 0.4s;
}

@keyframes load {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/react-chatbot-kit/components/ChatbotMessage/ChatbotMessage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".react-chatbot-kit-chat-bot-message-container {\n  display: flex;\n  margin: 15px 0;\n  justify-content: flex-start;\n}\n\n.react-chatbot-kit-chat-bot-avatar-container {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 1.2rem;\n  margin-right: 12.5px;\n  background-color: #d8d8d8;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.react-chatbot-kit-chat-bot-avatar-icon {\n  fill: #494646;\n  width: 22.5px;\n  height: 22.5px;\n}\n\n.react-chatbot-kit-chat-bot-avatar-letter {\n  color: #1d1d1d;\n  margin: 0;\n  padding: 0;\n}\n\n.react-chatbot-kit-chat-bot-message {\n  background-color: #2898ec;\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 0.9rem;\n  color: #fff;\n  font-weight: medium;\n  position: relative;\n  width: 184.5px;\n  margin-left: auto;\n  text-align: left;\n}\n\n.react-chatbot-kit-chat-bot-message-arrow {\n  width: 0;\n  height: 0;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-right: 8px solid #2898ec;\n  position: absolute;\n  left: -7px;\n  top: 13px;\n}\n\n.react-chatbot-kit-chat-bot-loading-icon-container {\n  height: 17px;\n  width: 25px;\n}\n\n.chatbot-loader-container {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n#chatbot-loader #chatbot-loader-dot1 {\n  animation: load 1s infinite;\n}\n\n#chatbot-loader #chatbot-loader-dot2 {\n  animation: load 1s infinite;\n  animation-delay: 0.2s;\n}\n\n#chatbot-loader #chatbot-loader-dot3 {\n  animation: load 1s infinite;\n  animation-delay: 0.4s;\n}\n\n@keyframes load {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
